"use strict";

var _regeneratorRuntime = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = require("axios");

var ApiFileReference_1 = require("./ApiFileReference");

var Client = function Client(_ref) {
  var _this = this;

  var endpoint = _ref.endpoint,
      axiosInstance = _ref.axiosInstance;

  _classCallCheck(this, Client);

  this.getFile = function (fileReferenceId, token) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var response, json;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.axiosInstance.request(Object.assign(Object.assign({
                url: "".concat(this.endpoint, "/files/").concat(fileReferenceId, "/detail?token=").concat(token),
                method: 'get'
              }, config), {
                withCredentials: false
              }));

            case 2:
              response = _context.sent;

              if (!(response.status !== 200)) {
                _context.next = 5;
                break;
              }

              throw new Error();

            case 5:
              _context.next = 7;
              return response.data;

            case 7:
              json = _context.sent;
              return _context.abrupt("return", ApiFileReference_1.default.fromJSON(json));

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));
  };

  this.getAllFilesInBucket = function (bucketId, token) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var tokenParam, response, json;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              tokenParam = token != null ? "?token=".concat(token) : '';
              _context2.next = 3;
              return this.axiosInstance.request(Object.assign(Object.assign({
                url: "".concat(this.endpoint, "/buckets/").concat(bucketId, "/files").concat(tokenParam),
                method: 'get'
              }, config), {
                withCredentials: token == null
              }));

            case 3:
              response = _context2.sent;

              if (!(response.status !== 200)) {
                _context2.next = 6;
                break;
              }

              throw new Error();

            case 6:
              _context2.next = 8;
              return response.data;

            case 8:
              json = _context2.sent;
              return _context2.abrupt("return", json.map(function (item) {
                return ApiFileReference_1.default.fromJSON(item);
              }));

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));
  };

  this.uploadFile = function (file, bucketId, organizationId) {
    var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var convert = arguments.length > 4 ? arguments[4] : undefined;
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var url, response, json;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = "".concat(this.endpoint, "/buckets/").concat(bucketId, "/files?convert=").concat(convert !== null && convert !== void 0 ? convert : false);

              if (organizationId) {
                url += "&org=".concat(organizationId);
              }

              _context3.next = 4;
              return this.axiosInstance.request(Object.assign({
                url: url,
                method: 'POST',
                data: file,
                headers: {
                  // Please do not set the 'content-length'. This is set automatically by axios.
                  'content-type': file.type,
                  'content-name': encodeURIComponent(file.name)
                }
              }, config));

            case 4:
              response = _context3.sent;

              if (!(response.status !== 200)) {
                _context3.next = 7;
                break;
              }

              throw new Error();

            case 7:
              _context3.next = 9;
              return response.data;

            case 9:
              json = _context3.sent;
              return _context3.abrupt("return", ApiFileReference_1.default.fromJSON(json));

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));
  };

  this.deleteFile = function (fileReferenceId, bucketId) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var response;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.axiosInstance.request(Object.assign({
                url: "".concat(this.endpoint, "/buckets/").concat(bucketId, "/files/").concat(fileReferenceId),
                method: 'DELETE'
              }, config));

            case 2:
              response = _context4.sent;

              if (!(response.status !== 204)) {
                _context4.next = 5;
                break;
              }

              throw new Error();

            case 5:
              return _context4.abrupt("return");

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));
  };

  axios_1.default.defaults.withCredentials = true;
  this.endpoint = endpoint;
  this.axiosInstance = axiosInstance || axios_1.default.create({
    baseURL: endpoint,
    withCredentials: true
  });
};

exports.default = Client;